import { useState, useEffect } from 'react';
import { FileIcon } from './FileIcon';
import { BlobItem } from '@/types';

interface FileThumbnailProps {
  item: BlobItem;
  size?: number;
}

// Renders the SharePoint/Graph thumbnail for an item (image, Office doc, PDF),
// falling back to the file-type icon for folders, unsupported types, or when the
// short-lived thumbnail URL fails to load. Native lazy-loading defers off-screen
// thumbnails.
export function FileThumbnail({ item, size = 16 }: FileThumbnailProps) {
  const [errored, setErrored] = useState(false);

  // A new listing produces fresh URLs; reset the error gate when the URL changes.
  useEffect(() => setErrored(false), [item.thumbnailUrl]);

  if (!item.isFolder && item.thumbnailUrl && !errored) {
    return (
      <img
        src={item.thumbnailUrl}
        alt=""
        className="file-thumbnail"
        style={{ width: size, height: size }}
        loading="lazy"
        onError={() => setErrored(true)}
      />
    );
  }

  return <FileIcon name={item.name} isFolder={item.isFolder} size={size} />;
}
